import { ContentDetailDialog } from "@/features/content/components/ContentDetailDialog";
import { ContentEditButton } from "@/features/content/components/ContentEditButton";
import { ContentRowActions } from "@/features/content/components/ContentRowActions";
import type { ContentEntry } from "@/types/content";

interface ContentPageActionsProps {
  entry: ContentEntry;
  departmentName?: string;
}

/**
 * Row actions for /admin/pages — Show and Edit are always available for published and draft pages;
 * workflow actions and delete live in ContentRowActions.
 *
 * 🔄 "draft-only delete" until 2026-09-17. Delete now offers itself on a published page too — see
 * ContentRowActions for why the old restriction left published pages deletable from nowhere.
 */
export function ContentPageActions({
  entry,
  departmentName,
}: ContentPageActionsProps) {
  return (
    <div className="flex items-center justify-end gap-2">
      <ContentDetailDialog entry={entry} departmentName={departmentName} />
      <ContentEditButton entry={entry} />
      <ContentRowActions entry={entry} />
    </div>
  );
}
